// extracted by mini-css-extract-plugin
export default {"preloader":"Bcvdv","clickable":"_Zkfq"};